// Author thq
// Date 2024-06-11 13:04:57

class EmSppRequisitionRwoSrr {
    constructor({
                    id = null,
                    srrIdRwo = '',
                    srrIdSpa = '',
                    srrIdSti = '',
                    srrCodeSpa = '',
                    srrNameSpa = '',
                    srrCodeSat = '',
                    srrNameSat = '',
                    srrCodeEloc = '',
                    srrNameEloc = '',
                    srrNum = '',
                    srrSpaIdentCode = '',
                    srrSidBda = '',
                    srrRemark = ''
                }
                    = {}) {
        this.id = id;
        this.srrIdRwo = srrIdRwo;
        this.srrIdSpa = srrIdSpa;
        this.srrIdSti = srrIdSti;
        this.srrCodeSpa = srrCodeSpa;
        this.srrNameSpa = srrNameSpa;
        this.srrCodeSat = srrCodeSat;
        this.srrNameSat = srrNameSat;
        this.srrCodeEloc = srrCodeEloc;
        this.srrNameEloc = srrNameEloc;
        this.srrNum = srrNum;
        this.srrSpaIdentCode = srrSpaIdentCode;
        this.srrSidBda = srrSidBda;
        this.srrRemark = srrRemark;
    }
}

function newEntity() {
    return new EmSppRequisitionRwoSrr();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.em.spareparts.emSppRequisitionRwoSrr.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'srrIdRwo',
            label: 'label.em.spareparts.emSppRequisitionRwoSrr.grid.srrIdRwo',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'srrIdSpa',
            label: 'label.em.spareparts.emSppRequisitionRwoSrr.grid.srrIdSpa',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'srrIdSti',
            label: 'label.em.spareparts.emSppRequisitionRwoSrr.grid.srrIdSti',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'srrCodeSpa',
            label: 'label.em.spareparts.emSppRequisitionRwoSrr.grid.srrCodeSpa',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'srrNameSpa',
            label: 'label.em.spareparts.emSppRequisitionRwoSrr.grid.srrNameSpa',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'srrCodeSat',
            label: 'label.em.spareparts.emSppRequisitionRwoSrr.grid.srrCodeSat',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'srrNameSat',
            label: 'label.em.spareparts.emSppRequisitionRwoSrr.grid.srrNameSat',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'srrCodeEloc',
            label: 'label.em.spareparts.emSppRequisitionRwoSrr.grid.srrCodeEloc',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'srrNameEloc',
            label: 'label.em.spareparts.emSppRequisitionRwoSrr.grid.srrNameEloc',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'srrNum',
            label: 'label.em.spareparts.emSppRequisitionRwoSrr.grid.srrNum',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'srrSpaIdentCode',
            label: 'label.em.spareparts.emSppRequisitionRwoSrr.grid.srrSpaIdentCode',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'srrSidBda',
            label: 'label.em.spareparts.emSppRequisitionRwoSrr.grid.srrSidBda',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'srrRemark',
            label: 'label.em.spareparts.emSppRequisitionRwoSrr.grid.srrRemark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        }
    ])
}

const filter = {
    idFilter: '',
    idListFilter: [],
    srrIdRwoFilter: '',
    srrIdSpaFilter: '',
    srrIdStiFilter: '',
    srrCodeSpaFilter: '',
    srrNameSpaFilter: '',
    srrCodeSatFilter: '',
    srrCodeElocFilter: '',
    srrNumFilter: '',
    srrSpaIdentCodeFilter: '',
    srrSidBdaFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'srrIdRwoFilter',
        label: 'label.em.spareparts.emSppRequisitionRwoSrr.filter.srrIdRwo',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'srrIdSpaFilter',
        label: 'label.em.spareparts.emSppRequisitionRwoSrr.filter.srrIdSpa',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'srrIdStiFilter',
        label: 'label.em.spareparts.emSppRequisitionRwoSrr.filter.srrIdSti',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'srrCodeSpaFilter',
        label: 'label.em.spareparts.emSppRequisitionRwoSrr.filter.srrCodeSpa',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'srrNameSpaFilter',
        label: 'label.em.spareparts.emSppRequisitionRwoSrr.filter.srrNameSpa',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'srrCodeSatFilter',
        label: 'label.em.spareparts.emSppRequisitionRwoSrr.filter.srrCodeSat',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'srrCodeElocFilter',
        label: 'label.em.spareparts.emSppRequisitionRwoSrr.filter.srrCodeEloc',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'srrNumFilter',
        label: 'label.em.spareparts.emSppRequisitionRwoSrr.filter.srrNum',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'srrSpaIdentCodeFilter',
        label: 'label.em.spareparts.emSppRequisitionRwoSrr.filter.srrSpaIdentCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'srrSidBdaFilter',
        label: 'label.em.spareparts.emSppRequisitionRwoSrr.filter.srrSidBda',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    }
];


const entityFormConfigs = [
    {
        key: 'srrIdRwo',
        label: 'label.em.spareparts.emSppRequisitionRwoSrr.entity.srrIdRwo',
        sortable: true,
        disabled: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'srrCodeSpa',
        label: 'label.em.spareparts.emSppRequisitionRwoSrr.entity.srrCodeSpa',
        sortable: true,
        disabled: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'srrNameSpa',
        label: 'label.em.spareparts.emSppRequisitionRwoSrr.entity.srrNameSpa',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emSparePartsInventorySpi'
            , correspondingField: 'spiNameSpa'
            , fieldsBindingByEntityModalSelected: '{"srrIdSti":"id","srrCodeSpa":"spiCodeSpa"}'
        }
    },
    {
        key: 'srrNum',
        label: 'label.em.spareparts.emSppRequisitionRwoSrr.entity.srrNum',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'srrRemark',
        label: 'label.em.spareparts.emSppRequisitionRwoSrr.entity.srrRemark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    }
]

export {
    EmSppRequisitionRwoSrr, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs


}
